import asyncComponent from '../../components/AsyncComponent';

const HandbookEditor = asyncComponent(() => import('../../containers/Handbook/Editor'));

export default HandbookEditor;
